import { c as _c } from "react/compiler-runtime";
import { ClickAwayListener, Popover } from '@mui/material';

/**
 * The popover every condition panel opens in. It is deliberately not modal: the surface behind keeps its mouse
 * events, so the page still scrolls and hovers and a click on another filter tag reaches that tag instead of being
 * swallowed. Nothing in front is left to catch that click, so closing runs off ClickAwayListener — it listens on the
 * document, which both lets the click through and, unlike a DOM-only check, still counts the portaled menus a panel
 * opens (operator select, sub-panels) as clicks inside.
 */
export const ConditionPanelPopover = t0 => {
  const $ = _c(15);
  const {
    open,
    anchorEl,
    onClose,
    children
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      vertical: "bottom",
      horizontal: "left"
    };
    t2 = {
      vertical: "top",
      horizontal: "left"
    };
    t3 = {
      pointerEvents: "none"
    };
    t4 = {
      paper: {
        sx: {
          marginTop: "4px",
          pointerEvents: "auto"
        }
      }
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== anchorEl || $[5] !== onClose) {
    t5 = event => {
      if (anchorEl?.contains(event.target as Node)) {
        return;
      }
      onClose();
    };
    $[4] = anchorEl;
    $[5] = onClose;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== t5) {
    t6 = <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={t5}>{children}</ClickAwayListener>;
    $[7] = children;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== anchorEl || $[11] !== onClose || $[12] !== open || $[13] !== t6) {
    t7 = <Popover open={open} anchorEl={anchorEl} onClose={onClose} hideBackdrop={true} disableScrollLock={true} disableEnforceFocus={true} anchorOrigin={t1} transformOrigin={t2} sx={t3} slotProps={t4}>{t6}</Popover>;
    $[10] = anchorEl;
    $[11] = onClose;
    $[12] = open;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};